import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || 
        err.name === 'NavigationRedirected' ||
        err.message.includes('Redirected') ||
        err.message.includes('Navigation')) {
      return err
    }
    throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || 
        err.name === 'NavigationRedirected' ||
        err.message.includes('Redirected') ||
        err.message.includes('Navigation')) {
      return err
    }
    throw err
  })
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/database',
    name: 'Database',
    component: () => import('@/views/Database.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/forum',
    name: 'Forum',
    component: () => import('@/views/Forum.vue')
  },
  {
    path: '/forum/board/:id',
    name: 'ForumBoard',
    component: () => import('@/views/ForumBoard.vue')
  },
  {
    path: '/forum/post/:id',
    name: 'ForumPost',
    component: () => import('@/views/ForumPost.vue')
  },
  {
    path: '/forum/new',
    name: 'ForumNew',
    component: () => import('@/views/ForumNew.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/center',
    name: 'UserCenter',
    component: () => import('@/views/UserCenter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/following',
    name: 'FollowingList',
    component: () => import('@/views/FollowingList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/followers',
    name: 'FollowerList',
    component: () => import('@/views/FollowerList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/notifications',
    name: 'Notifications',
    component: () => import('@/views/Notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import('@/views/Protocol.vue')
},
{
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/Privacy.vue')
},{
    path: '/database/manufacturers',
    name: 'Manufacturers',
    component: () => import('@/views/Manufacturers.vue')
},
{
    path: '/database/manufacturer/:id',
    name: 'ManufacturerModels',
    component: () => import('@/views/ManufacturerModels.vue')
},
{
    path: '/database/series/:id',
    name: 'SeriesModels',
    component: () => import('@/views/SeriesModels.vue')
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ 
      path: '/login', 
      query: { redirect: to.fullPath },
      replace: true
    })
    return
  }
  
  if (to.meta.requiresGuest && isLoggedIn) {
    next({ path: '/', replace: true })
    return
  }
  
  next()
})

router.afterEach(() => {})

export default router